// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ActiveStatus } from './active-status';
import { ProductType } from './product-type';
import { ProximityUser } from './proximity-user';
import { ReviewGuideline } from './review-guideline';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountGuidelineException extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK account */
  accountId!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Guid FK createdByUser */
  createdByUserId!: string;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** Guid FK productType */
  productTypeId?: string;
  /** String */
  reason!: string;
  /** Guid FK reviewGuideline */
  reviewGuidelineId!: string;
  /** Binary */
  rowVersion!: any;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK createdByUserId */
  createdByUser!: ProximityUser;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK reviewGuidelineId */
  reviewGuideline!: ReviewGuideline;
}

